/* Svensk katalog for locale-firm-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'rf.loading.firm': 'Läser in din byrå …',
  'rf.loading.clients': 'Hämtar dina klienter …',
  'rf.loading.reconciliation': 'Hämtar avstämningarna …',
  'rf.loading.control': 'Hämtar kontrolluppgifterna …',
  'rf.loading.ledger': 'Läser in klientens bokföring …',
  'rf.pageError.title': 'Sidan kunde inte läsas in',
  'rf.pageError.text': 'Läs in byråvyn igen. Om det kvarstår är skriptet för den här sidan inte tillgängligt.',
  'rf.client.assignCount': 'Tilldela ({count})',
  'rf.client.assignAll': 'Alla i byrån',
  'rf.client.assignNobody': 'Byrån har inga aktiva medarbetare att tilldela uppdraget ännu.',
  'rf.client.assignRoleHint': 'Rollen gäller alla du har kryssat i. Är någon redan tilldelad får de den nya rollen.',
  'rf.client.assignedMany': '{count} medarbetare är tilldelade uppdraget',
  'rf.nav.myPage': 'Min sida',
  'rf.nav.firmBooks': 'Till byråns bokföring',
});
